import { Injectable } from "@angular/core";
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";

import { AuthService } from "./auth.service";
import { CachedUserService } from "./cached-user.service";
import { take } from "rxjs/operators";

@Injectable()
export class AuthGuardService  {
  constructor(
    private auth: AuthService,
    private cachedUserService: CachedUserService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isAuthenticated()) {
      if (state.url.includes("/xwai")) {
        let userDetail = await this.cachedUserService
          .getUserDetails()
          .pipe(take(1))
          .toPromise();
        if (userDetail && userDetail.xwaiAccess) {
          return true;
        } else {
          return false;
        }
      }
      if (state.url.includes("/ec2-instances")) {
        let userDetail = await this.cachedUserService
          .getUserDetails()
          .pipe(take(1))
          .toPromise();
        if (userDetail && userDetail.isStaff) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
